<template>
  <transition name="modal-fade">
    <div class="modal-overlay" v-if="visible" @click.self="cancel">
      <div class="modal-box">
        <div class="modal-icon" :class="type">
          <span v-if="type === 'warning'">!</span>
          <span v-else-if="type === 'error'">✕</span>
          <span v-else>i</span>
        </div>
        <div class="modal-title">{{ title }}</div>
        <div class="modal-message">{{ message }}</div>
        <div class="modal-actions">
          <button class="modal-btn cancel" @click="cancel">{{ cancelText }}</button>
          <button class="modal-btn confirm" @click="confirm">{{ confirmText }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { eventBus } from '../plugins/dialog'

export default {
  name: 'ConfirmDialog',
  data() {
    return {
      visible: false,
      title: '',
      message: '',
      type: 'warning',
      confirmText: '确定',
      cancelText: '取消',
      currentResolve: null
    }
  },
  created() {
    eventBus.$on('confirm:show', (options) => {
      this.show(options)
    })
  },
  methods: {
    show(options) {
      this.title = options.title || '提示'
      this.message = options.message || ''
      this.type = options.type || 'warning'
      this.confirmText = options.confirmText || '确定'
      this.cancelText = options.cancelText || '取消'
      this.currentResolve = options.resolve || null
      this.visible = true
    },
    confirm() {
      this.visible = false
      if (this.currentResolve) this.currentResolve(true)
    },
    cancel() {
      this.visible = false
      if (this.currentResolve) this.currentResolve(false)
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.modal-box {
  background: #fff;
  border-radius: 20px;
  padding: 36px 32px 28px;
  width: 380px;
  max-width: 90vw;
  text-align: center;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.15);
}

.modal-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin: 0 auto 20px;
}

.modal-icon.warning { background: #f59e0b; }
.modal-icon.error { background: #ef4444; }
.modal-icon.info { background: #2563eb; }

.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 10px;
}

.modal-message {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 28px;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.modal-btn {
  padding: 10px 32px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.modal-btn.cancel {
  background: #f0f0f0;
  color: #4b5563;
}

.modal-btn.cancel:hover {
  background: #e5e7eb;
}

.modal-btn.confirm {
  background: #2563eb;
  color: #fff;
}

.modal-btn.confirm:hover {
  background: #1d4ed8;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: all 0.25s ease;
}

.modal-fade-enter {
  opacity: 0;
}

.modal-fade-enter .modal-box {
  transform: scale(0.9);
}

.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-leave-to .modal-box {
  transform: scale(0.9);
}
</style>
